export default ".switcher {\n  position: fixed;\n  bottom: 0.4rem;\n  right: 0.4rem;\n  border-radius: 50%;\n}"